/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../apiClient'
import type {
  Client,
  RequestConfig,
  ResponseErrorConfig,
} from '../../apiClient'
import type {
  SearchChainsQueryResponse,
  SearchChainsQueryParams,
} from '../types/SearchChains'

function getSearchChainsUrl() {
  const res = {
    method: 'GET',
    url: `/api/v1/common/search/chains_name_and_domain/` as const,
  }
  return res
}

/**
 * @description Handle GET request for search.
 * This is the main entry point that orchestrates the search process.
 * @summary Search FirstBite chains by name or domain
 * {@link /api/v1/common/search/chains_name_and_domain/}
 */
export async function searchChains(
  params: SearchChainsQueryParams,
  config: Partial<RequestConfig> & { client?: Client } = {}
) {
  const { client: request = fetch, ...requestConfig } = config

  const res = await request<
    SearchChainsQueryResponse,
    ResponseErrorConfig<Error>,
    unknown
  >({
    method: 'GET',
    url: getSearchChainsUrl().url.toString(),
    params,
    ...requestConfig,
  })
  return res.data
}
